import { DebugDataBox } from "./DebugDataBox";
import { Helper } from "../../../utils/Helper";
import { GameSetting } from "../../../setting/GameSetting"
import { StageLayer } from "@nolimitcity/slot-launcher/bin/StageLayer";
import { BaseModel } from "../../../../game/server/base/BaseModel";
import {  gsap } from "gsap";

export class TestTool extends PIXI.Container implements StageLayer {

    private dataBox:DebugDataBox;
    private tl:gsap.core.Timeline;

    private static triggerInit:Function;
    private static quickCommand:Function;
    private static triggerInteraction:Function;
    private static triggered:boolean = false;

    private activated:boolean = false;

    constructor(modelData:BaseModel){
        super()
        if(GameSetting.isDevMode) {
            
            TestTool.triggerInit = () => {
                this.dataBox = this.addChild(new DebugDataBox(modelData))
                this.dataBox.position.set(-280,-180)
            };

            TestTool.quickCommand = (val:string) => {
                if(TestTool.triggered && this.activated){
                    this.dataBox.onQuickCommand(val);
                }
            };
            TestTool.triggerInteraction = () => this.animateVisible();
            
            this.addBaseEventListeners();

            this.position.set(360,360);
        }
    }
    private addBaseEventListeners():void{

        document.addEventListener("keydown", function (e) {
            let toggle:boolean = true;
            switch (e.key) {
                case "O":// O
                case "o":// o
                    break;
                default:
                    toggle = false;
                    break;
            }
            if(toggle){
                if(!TestTool.triggered){
                    TestTool.triggerInit();
                    TestTool.triggered = !TestTool.triggered;
                }
                TestTool.triggerInteraction();
            }
            else {
                if(TestTool.triggered){
                    TestTool.quickCommand(e.key);
                }
            }
        }, false);
    }

    public animateVisible():void{

        this.activated = !this.activated;
        
        this.tl = Helper.setTimeline(this.tl, new gsap.core.Timeline({
            onStart:() => {this.visible = true},
            onComplete:() => {
                this.visible = this.activated;
                if(!this.visible) this.dataBox.disableBtns();
            },
        }));

        if(this.activated){
            this.tl.fromTo(this.scale,{x:0,y:0},{x:1,y:1,duration:0.25},0)
            this.tl.fromTo(this,{alpha:0},{alpha:1,duration:0.25},0)
        }else{
            this.tl.fromTo(this.scale,{x:1,y:1},{x:0,y:0,duration:0.25},0)
            this.tl.fromTo(this,{alpha:1},{alpha:0,duration:0.25},0)
        }
    }

    public onResize():void {
        this.tl = Helper.setTimeline(this.tl, new gsap.core.Timeline(), true)
    }
}
